import { ServiceCodeBySystem, IntegrationSystem } from '@/shared/types';

import { config } from '@/config/index';

import { RouteConfig } from '@/router/types';

export const ARS_ROUTES: Record<keyof ServiceCodeBySystem<IntegrationSystem.ARS>, RouteConfig> = {
  CITIZEN_APPEAL_TO_MVS: { basePath: config.router.servicePath, path: 'citizen-appeal-to-mvs', isPrivate: true },
  SEARCH_INCOMING_CORRESPONDENCE: {
    basePath: config.router.servicePath,
    path: 'search-incoming-correspondence',
    isPrivate: false,
  },
};
